import { applyMiddleware, combineReducers, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import logger from 'redux-logger';
import { composeWithDevTools as devTools } from 'redux-devtools-extension';

import appReducer from './actions';
import userReducer from './actions/user';
import sagas from './sagas';

const mainReducer = combineReducers({
  app: appReducer,
  users: userReducer,
});

const configureStore = () => {
  const middlewares = [];

  const sagaMiddleware = createSagaMiddleware();
  middlewares.push(sagaMiddleware);

  let appliedMiddleware = applyMiddleware(...middlewares);

  if (process.env.NODE_ENV !== 'production') {
    middlewares.push(logger);
    appliedMiddleware = devTools(appliedMiddleware);
  }

  const store = createStore(
    mainReducer,
    appliedMiddleware,
  );

  sagaMiddleware.run(sagas);

  return store;
};

export default configureStore;



// WEBPACK FOOTER //
// ./src/configureStore.js